import { TenantType } from '@debbie/common/dist/tenants/index.js';
import BillingGroup from './BillingGroup.js';
import CasesGroup from './CasesGroup.js';
import ContactsGroup from './ContactsGroup.js';
import CreditorsGroup from './CreditorsGroup.js';
import DocumentsGroup from './DocumentsGroup.js';
import EconomyGroup from './EconomyGroup.js';
import InteractionsGroup from './InteractionsGroup.js';
import PaginationGroup from './PaginationGroup.js';
import PaymentPlansGroup from './PaymentPlansGroup.js';
import PropertiesGroup from './PropertiesGroup.js';
import UpdatesGroup from './UpdatesGroup.js';
import WorkflowsGroup from './WorkflowsGroup.js';
export default {
    [TenantType.AccountsReceivable]: [
        CasesGroup,
        UpdatesGroup,
        EconomyGroup,
        DocumentsGroup,
        WorkflowsGroup,
        PaymentPlansGroup,
        ContactsGroup,
        InteractionsGroup,
        PropertiesGroup,
        PaginationGroup,
    ],
    [TenantType.Agency]: [
        CreditorsGroup,
        CasesGroup,
        UpdatesGroup,
        EconomyGroup,
        BillingGroup,
        DocumentsGroup,
        WorkflowsGroup,
        PaymentPlansGroup,
        ContactsGroup,
        InteractionsGroup,
        PropertiesGroup,
        PaginationGroup,
    ],
};
//# sourceMappingURL=index.js.map